import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'core-error-page',
  styleUrls: ['./error-page.component.scss'],
  templateUrl: './error-page.component.html'
})
export class ErrorPageComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
